module.exports = __webpack_public_path__ + "img/img68.63de354f.png";